module.exports = __webpack_public_path__ + "static/media/Munchbox.082acfcd.png";